// ── Districts ──────────────────────────────────────────────────────────────────

export function buildDistrictFeatures(districts: any[]): GeoJSON.Feature[] {
    const features: GeoJSON.Feature[] = [];
  
    for (const d of districts) {
      if (typeof d?.getOutlinesAsFeatureList !== 'function') continue;
      try {
        const outlineFeatures: GeoJSON.Feature[] = d.getOutlinesAsFeatureList() ?? [];
        outlineFeatures.forEach(f => {
          features.push({
            ...f,
            properties: { ...(f.properties ?? {}), id: d.identifier },
          });
        });
      } catch (e) {
        console.error(`[buildDistrictFeatures] Failed for district ${d.identifier}`, e);
      }
    }
  
    return features;
  }
  
  // ── Game records ───────────────────────────────────────────────────────────────
  
  
  const WILDART_ICON_MAP: Readonly<Record<string, string>> = {
    schwarzwild: 'icnSchwarzwild',
    damwild:     'icnDamwild',
    rehwild:     'icnRehwild',
    nutria:      'icnNutria',
    fuchs:       'icnFuchs',
    dachs:       'icnDachs',
    waschbär:    'icnWaschbär',
    sikawild:    'icnSikawild',
    muntjac:     'icnMuntjac',
    muffelwild:  'icnMuffelwild',
    rotwild:     'icnRotwild',
  };
  
  /** Resolve a game record's Wildart name to a Mapbox icon identifier. */
  export function resolveGameRecordIcon(wildart: string): string {
    return WILDART_ICON_MAP[wildart?.toLowerCase()] ?? 'icon-pin';
  }
  